import { render, staticRenderFns } from "./consolidado_siat.vue?vue&type=template&id=dbcec65e&scoped=true"
import script from "./consolidado_siat.vue?vue&type=script&lang=js"
export * from "./consolidado_siat.vue?vue&type=script&lang=js"
import style0 from "./consolidado_siat.vue?vue&type=style&index=0&id=dbcec65e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbcec65e",
  null
  
)

export default component.exports